import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./Checkbox.scss";
import { Label } from "@client.components/Modal";

export const FormCheckbox = ({
  value = false,
  onChange,
  label = "",
  className,
}) => {
  return (
    <>
      <Label term={label} />
      <div className={classNames("checkbox-container", className)}>
        <label className="container">
          <input
            type="checkbox"
            checked={value}
            onChange={(v) => onChange(v.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    </>
  );
};

FormCheckbox.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};
